import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('userToken');
        if (token) {
            // Zde byste měli načíst údaje o uživateli pomocí tokenu nebo alespoň ověřit platnost tokenu
            // Příklad: setUser({ token });
            // Pro jednoduchost zde předpokládáme, že uživatel je přihlášen, pokud existuje token
            setUser({ token }); // Nastavení uživatele jako přihlášeného
        }
    }, []);

    const login = (userData, token) => {
        console.log( token );
        localStorage.setItem('userToken', token);
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem('userToken');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

